// Navigation menu (BEGIN)
// Desktop (BEGIN)
// Submenu open/close control (BEGIN)
document.querySelectorAll(
    'body > header > div > section#mobile_menu_container > nav > ul#header_menu_list > li.root-parent-menu-item > a'
).forEach(linkElement => {
    linkElement.addEventListener('click', function (event) {
        event.preventDefault();

        // Close all other possible submenu opened
        Array.from(event.currentTarget.parentNode.parentNode.children).forEach(listItemElement => {
            if (listItemElement !== linkElement.parentNode) {
                listItemElement.classList.remove('active');
            }
        });

        // Open/close the clicked submenu when it's closed/opened
        event.currentTarget.parentNode.classList.toggle('active');
    });
});
// Submenu open/close control (END)

// Close submenu when clicking anywhere outside header (BEGIN)
document.querySelectorAll('body > :not(header)').forEach(element => {
    element.addEventListener('click', function () {
        document.querySelectorAll(
            'body > header > div > section#mobile_menu_container > nav > ul#header_menu_list > li.root-parent-menu-item'
        ).forEach(listItemElement => {
            listItemElement.classList.remove('active');
        });
    });
});
// Close submenu when clicking anywhere outside header (END)
// Desktop (END)

document.getElementById('mobile_menu_toggle_button').addEventListener('click', function () {
    this.parentNode.classList.toggle('active');
});

// Polylang switcher
const switcher = document.getElementById('polylang_switcher');

if (switcher === null) {
    throw new DOMException('Polylang switcher element not found.');
}

switcher.querySelector('button').addEventListener('click', () => {
    switcher.classList.toggle('open');
});

// Close switcher when clicking anywhere outside header (BEGIN)
document.addEventListener('click', event => {
    if (!switcher.contains(event.target)) {
        switcher.classList.remove('open');
    }
})
